export default [
  {
    path: "/likedetailfour",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  {
    path: "/likedetailfive",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  {
    path: "/likedetailsix",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  {
    path: "/likedetailseven",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  {
    path: "/likedetaileight",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  {
    path: "/likedetailnine",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  {
    path: "/likedetailten",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  {
    path: "/likedetaileleven",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  {
    path: "/likedetailtwelve",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  {
    path: "/likedetailthirteen",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  {
    path: "/likedetailfourteen",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  {
    path: "/likedetailfifteen",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  {
    path: "/likedetailsixteen",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  {
    path: "/likedetailseventeen",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  {
    path: "/likedetaileighteen",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  {
    path: "/likedetailnineteen",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  {
    path: "/likedetailtwenty",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },

  // 公共
  {
    path: "/likedetailbase",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  /** 2022 05 24  */
  {
    path: "/likedetaila",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  {
    path: "/likedetailb",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  {
    path: "/likedetailc",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  {
    path: "/likedetaild",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  {
    path: "/likedetaile",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  {
    path: "/likedetailf",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  {
    path: "/likedetailg",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  {
    path: "/likedetailh",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  {
    path: "/likedetaili",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  {
    path: "/likedetailj",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
  {
    path: "/likedetailk",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
  },
]